module.exports = __webpack_public_path__ + "static/media/IMG_1223.93420946.JPG";